import { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { siteConfig } from "../data/siteConfig";
import { roomsData } from "../data/roomsData";

const BookingForm = () => {
  const [form, setForm] = useState({
    name: "", phone: "", email: "", checkin: "", checkout: "",
    guests: "2", roomType: roomsData[0].name, message: "",
  });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const text =
      `New Booking Enquiry – USHA Resort\n\n` +
      `Name: ${form.name}\n` +
      `Phone: ${form.phone}\n` +
      `Email: ${form.email || "-"}\n` +
      `Check-in: ${form.checkin}\n` +
      `Check-out: ${form.checkout}\n` +
      `Guests: ${form.guests}\n` +
      `Room / Venue: ${form.roomType}\n` +
      `Message: ${form.message || "-"}`;

    window.open(`https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent(text)}`, "_blank");
    setSent(true);
  };

  return (
    <form className="booking-form" onSubmit={handleSubmit}>
      <h3>Quick Enquiry</h3>
      <p className="form-note">Fill in your details — our team will confirm availability on WhatsApp within minutes.</p>

      <div className="form-grid">
        <div className="form-group">
          <label>Full Name *</label>
          <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Your name" required />
        </div>
        <div className="form-group">
          <label>Phone Number *</label>
          <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="+91 ..." required />
        </div>
        <div className="form-group">
          <label>Email (optional)</label>
          <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
        </div>
        <div className="form-group">
          <label>Guests</label>
          <select name="guests" value={form.guests} onChange={handleChange}>
            {["1", "2", "3", "4", "5+"].map((g) => (
              <option key={g} value={g}>{g} Guest{g === "1" ? "" : "s"}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Check-in Date *</label>
          <input type="date" name="checkin" value={form.checkin} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Check-out Date *</label>
          <input type="date" name="checkout" value={form.checkout} onChange={handleChange} required />
        </div>
        <div className="form-group full">
          <label>Room / Venue</label>
          <select name="roomType" value={form.roomType} onChange={handleChange}>
            {roomsData.map((r) => <option key={r.id} value={r.name}>{r.name}</option>)}
            <option value="Banquet / Wedding Enquiry">Banquet / Wedding Enquiry</option>
            <option value="Pool Party / Day Outing">Pool Party / Day Outing</option>
            <option value="Corporate Event">Corporate Event</option>
          </select>
        </div>
        <div className="form-group full">
          <label>Message</label>
          <textarea name="message" value={form.message} onChange={handleChange} placeholder="Any special requests..." />
        </div>

        {sent && <div className="form-success">✅ Enquiry ready! WhatsApp should have opened — just press Send.</div>}

        <button type="submit" className="btn btn-gold booking-submit">
          <FaWhatsapp /> Send Enquiry on WhatsApp
        </button>
      </div>
    </form>
  );
};

export default BookingForm;